import { style } from "@vanilla-extract/css";
import { breakpoints, vars } from "plos/src/styles";

export const actionButtons = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.s,
  "@media": {
    [`(min-width: ${breakpoints[1]})`]: {
      flexDirection: "row",
      justifyContent: "space-between",
    },
  },
});
